import React, { useEffect, useState, useCallback } from 'react';
import {
  Button,
  Table as MuiTable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  styled
} from '@mui/material';
import { dateFormatter, getReccurssiveObjectKeys } from '../../../../../utils';
import { Checkbox } from '../../../../../components';
import EditIcon from '@mui/icons-material/Edit';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  padding: theme.spacing(0.9),
  whiteSpace: 'nowrap',
  fontSize: '13px',
  fontWeight:700
}));

export const StockTransferVoucherTable = ({
  data,
  columns,
  onRowClick,
  containerSX,
  sx,
  showOk,
  handleRowSelect,
  isSelected,
  editMedicine,
  onClickEdit,
}) => {
  return (
    <TableContainer sx={{ maxHeight: '259px', overflowY: 'auto', ...containerSX }}>
      <MuiTable sx={sx}>
        <TableHead>
          <TableRow sx={{ backgroundColor: 'lightblue' }}>
            {showOk && (
              <StyledTableCell key="ok-cell" sx={{ fontWeight: 'bold' }}>
              Approve
              </StyledTableCell>
            )}
           
            <StyledTableCell key="sr.no.-cell" sx={{ fontWeight: 'bold' }}>
              Sr. No.
            </StyledTableCell>
            {columns.map((column, index) => (
              <StyledTableCell sx={{ fontWeight: 'bold' }} key={`header-cell-${index}`}>
                {column.header}
              </StyledTableCell>
            ))}
               {editMedicine && (
              <StyledTableCell key="edit-cell" sx={{ fontWeight: 'bold' }}>
                Edit
              </StyledTableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {data?.map(
            (row, rowIndex) => (
              (
                <TableRow
                  {...(onRowClick && {
                    onClick: () => {
                      onRowClick(row);
                    }
                  })}
                  sx={{
                    backgroundColor: rowIndex % 2 ? 'grey.200' : 'none',
                    cursor: onRowClick ? 'pointer' : 'default',
                    '&:hover': {
                      backgroundColor: 'grey.300'
                    },
                    transition: 'all 0.1s ease-in',
                    backgroundColor: isSelected(row, 'ok') ? 'lightgreen' : 'none',
                    '&:hover': { backgroundColor: 'grey.300' }
                  }}
                  key={rowIndex}
                >
                  {showOk && (
                    <StyledTableCell>
                      <Checkbox
                        sx={{
                          transform: 'scale(0.8)',
                          padding: '0'
                        }}
                        name={row?._id}
                        disabled={false}
                        checked={isSelected(row, 'ok')}
                        onChange={() => handleRowSelect(row, 'ok')}
                      />
                    </StyledTableCell>
                  )}
           
                  <StyledTableCell key={`${row._id}-cell0`}>{rowIndex + 1}</StyledTableCell>
                  
                  {columns.map(({ header, accessor, sx }, colIndex) => (
                    <StyledTableCell sx={sx} key={`${row._id}-cell${colIndex + 1}`}>
                      {typeof accessor === 'function' ? (
                        accessor(row) || '0'
                      ) : (
                        <>
                          {header === 'Created At' || header === 'Date'
                            ? dateFormatter(getReccurssiveObjectKeys(row, accessor)) || '-'
                            : getReccurssiveObjectKeys(row, accessor) || '0'}
                        </>
                      )}
                    </StyledTableCell>
                  ))}
                  
                  {editMedicine && (
                <StyledTableCell key={`${row._id}-edit-cell`} sx={{cursor:"pointer"}}>
                  <EditIcon onClick={() => onClickEdit(row)} type="submit" />
                </StyledTableCell>
              )}
                </TableRow>
              )
            )
          )}
        </TableBody>
      </MuiTable>
    </TableContainer>
  );
};
